/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Close_LabelInputs */



/**
* | output |
* | --- |
* | "Close file import" |
*
* @param {File_Import_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_close_label = /** @type {((inputs?: File_Import_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Close file import")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateiimport schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi importazione file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть импорт файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar importación de archivos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭文件导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルのインポートを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल आयात बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar importação de arquivos")
	return /** @type {LocalizedString} */ ("Close file import")
});